import * as React from "react";
import {Component, CSSProperties, ReactHTML} from "react";
import {StoreBase} from "../../../utilities/Store/StoreBase";
import {StoreControl, StoreControlProps, StoreControlState} from "../../base/StoreControl";
import {ValidatorBase} from "../../../utilities/validator/ValidatorBase";
import {observer} from "mobx-react";

@observer
export class RNCheckBox <S extends StoreBase> extends StoreControl<RNCheckBoxProps<S>, RNCheckBoxState> {
    static defaultProps: Partial<RNCheckBoxProps<any>> = {
        disabled:false
    };

    constructor(props: RNCheckBoxProps<S>) {
        super(props);
        this.state = {
            IsValid:true,
            ErrorMessage:''
        };

    }

    public render() {
        return (
            <div className={'rncontrol rncheckbox'} style={{...this.props.style,display:'flex',alignItems:'center'}}>

                    <input disabled={this.props.disabled} style={{outline:'none',margin:0}} type={'checkbox'} value={this.GetBoolValue()} onChange={(e)=>{this.SetValue(e.target.checked)}} checked={this.GetBoolValue()}/>
                    <label onClick={()=>{if(!this.props.disabled)this.SetValue(!this.GetBoolValue())}} style={{width:'auto',cursor:'pointer',display:'block',margin:'0 0 0 3px',userSelect:'none'}}>{this.props.Label}</label>

            </div>
        )
    }

    GetValidators(): ValidatorBase[] {
        return [];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNCheckBoxProps<S extends StoreBase> extends StoreControlProps<S> {
    style?:CSSProperties;
    Label:string|JSX.Element;
    disabled?:boolean;
}

interface RNCheckBoxState extends StoreControlState{

}

//#endregion "My Region"